export default [
    {
        path: 'impressao-faa-eletronica',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-impressao-faa-eletronica' */
            '@/views/pronto-atendimento/impressao-faa-eletronica/Index'
        ),
        redirect: 'impressao-faa-eletronica/index',
        children: [
            {
                name: 'pronto-atendimento-impressao-faa-eletronica-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-impressao-faa-eletronica' */
                    '@/views/pronto-atendimento/impressao-faa-eletronica/List'
                ),
            },
        ]
    }
]